import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router'; // further imports omitted
import { Button, Nav, Row, Col, Popover, OverlayTrigger } from 'react-bootstrap';
import Warning from '@material-ui/icons/Warning';
import { noProperty, getErrorIssues, getWarningIssues } from '../../../../utils/validationSummary';

class LedmoduleHeader extends React.Component {

    interval = null;

    constructor(props) {

        super(props);

        this.state = {
            label: '',
            class: "saved-label",
            selectedKey: window.location.hash,
        };
    }

    closeLedmodule() {
        this.props.history.push('/');
    }

    render() {

        const infoUrl = `#/ledmodules/${this.props.ledmodule.id !== null ? this.props.ledmodule.id : 'new'}/info`;

        const errors = getErrorIssues(this.props.issues, { id: noProperty });
        const warnings = getWarningIssues(this.props.issues, { id: noProperty });

        let issueComponent = null;
        if (errors && errors.length > 0) {

            const errorsItems = [];
            errors.forEach(error => {
                if (error.name && errors.indexOf(error.name) === -1) {
                    errorsItems.push(error.name + ': ' + error.description);
                }
            });

            if (errorsItems.length > 0) {
                const popover = (
                    <Popover id="popover-basic">
                        <Popover.Title as="h3" className="error-popover" >Errors</Popover.Title>
                        <Popover.Content>
                            {errorsItems.join(", ")}
                        </Popover.Content>
                    </Popover>
                );

                issueComponent = (
                    <OverlayTrigger placement="right" trigger="click" overlay={popover}>
                        <Warning style={{ margin: 'auto', color: '#dc3545' }} />
                    </OverlayTrigger>
                );
            }
        }

        if (issueComponent === null && warnings && warnings.length > 0) {

            let warningsItems = [];
            warnings.forEach(warning => {
                if (warning.name && warnings.indexOf(warning.name) === -1) {
                    warningsItems.push(warning.name + ': ' + warning.description);
                }
            });

            if (warningsItems.length > 0) {
                const popover = (
                    <Popover id="popover-basic">
                        <Popover.Title as="h3" className="error-popover" >Warnings</Popover.Title>
                        <Popover.Content>
                            {warningsItems.join(", ")}
                        </Popover.Content>
                    </Popover>
                );

                issueComponent = (
                    <OverlayTrigger placement="right" trigger="click" overlay={popover}>
                        <Warning style={{ margin: 'auto', color: '#f0ad4e' }} />
                    </OverlayTrigger>
                );
            }
        }

        return (
            <Row className="ledmodule-header-container">
                <Col sm={5}>
                    <Nav variant="tabs" activeKey={this.state.selectedKey} onSelect={selectedKey => this.setState({ selectedKey: selectedKey })} >
                        <Nav.Item>
                            <Nav.Link href={infoUrl}>LED Module</Nav.Link>
                        </Nav.Item>
                    </Nav>
                </Col>
                <Col sm={2} className={this.state.class}>
                    {this.state.label}
                </Col>
                <Col sm={5} className="end">
                    {issueComponent}
                    <Button
                        variant="primary"
                        disabled={this.props.disabled || (!this.props.ledmodule.isPublished && !this.props.ledmoduleEdited) || (this.props.validationSummary && !this.props.validationSummary.isValid) || (this.props.ledmoduleName === undefined || this.props.ledmoduleName === null || this.props.ledmoduleName.trim() === '')}
                        className="edit-icon-ledmodule-header"
                        onClick={(e) => this.props.saveLedmodule(e)}>
                        {this.props.saveLedmoduleButtonText}
                    </Button>
                    {
                        !this.props.ledmoduleIsNew && this.props.ledmodule && !this.props.ledmodule.isPublished
                        ?
                        <Button
                            variant="primary"
                            disabled={this.props.disabled || this.props.ledmoduleEdited}
                            className="edit-icon-ledmodule-header"
                            onClick={(e) => this.props.publishLedmodule(e)}>
                            {this.props.publishLedmoduleButtonText}
                        </Button>
                        :
                        null
                    }
                    
                    {/* <Button variant="secondary"
                        disabled={this.props.disabled}
                        className="edit-icon-ledmodule-header"
                        onClick={(e) => this.props.copyLedmodule(e)}>
                        {this.props.copyLedmoduleButtonText}
                    </Button> */}
                    <Button variant="secondary"
                        disabled={this.props.disabled || this.props.ledmoduleIsNew}
                        className="edit-icon-ledmodule-header"
                        onClick={(e) => this.props.downloadLedmodule(e)}>
                        {this.props.downloadLedmoduleButtonText}
                    </Button>
                    {/* <Close className="close-icon-ledmodule-header" onClick={(e) => this.closeLedmodule()} /> */}
                </Col>
            </Row>
        );
    }
};

const mapStateToProps = (state, ownProps) => {
    return {
        ledmodule: state.ledmodule.info,
        ledmoduleIstemporary: state.ledmodule.isTemporary,
        issues: state.ledmodule.issueByProperty,
        validationSummary: state.ledmodule.validationSummary,
    };
};

const mapDispatchToProps = {
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(LedmoduleHeader));